import PropTypes from 'prop-types'
import useEducationFeatures from '../hooks/useEducationFeatures'

EducationFeature.propTypes = {
  name: PropTypes.string,
  variate: PropTypes.string,
  children: PropTypes.node,
  orElse: PropTypes.node
}

export default function EducationFeature({ name, variate = null, children = null, orElse = null }) {
  const features = useEducationFeatures()

  if (!name) return children

  if (!features) return null

  const feature = features[name]

  if (!feature) return orElse

  if (feature.variate_id) {
    return feature.variate_id === variate ? children : orElse
  } else {
    return children
  }
}
